//
// Module for Security Administration External Login Requests
//
rs.module("content/security/administration/externalloginrequests",

    [ ],

    function () {

        // Initialize the module
        function initialize(jsSelectors, backendUrl) {

            var filter = $.js(jsSelectors.filter);
            var statusSelect = filter.js(jsSelectors.statusSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);
            var gridContainer = $.js(jsSelectors.gridContainer);

            var modalForm = $.js(jsSelectors.modalForm);

            var requestKeyHiddenField = modalForm.js(jsSelectors.requestKeyHiddenField);
            var requestorNameHiddenField = modalForm.js(jsSelectors.requestorNameHiddenField);

            var modalPopup = modalForm.js(jsSelectors.modalPopup);
            var modalPopupCancelButton = modalPopup.js(jsSelectors.modalPopupCancelButton, { multiple: true });
            var modalRequestedBy = modalPopup.js(jsSelectors.modalRequestedBy);
            var modalRejectReasonTextArea = modalPopup.js(jsSelectors.modalRejectReasonTextArea);

            // On status selection change, update the grid display
            statusSelect.change(function () {

                loadingSpinner.show();

                $.get(backendUrl, { status: statusSelect.val() })
                    .done(function (html) {
                        gridContainer.html(html);
                    })
                    .always(function () {
                        loadingSpinner.hide();
                    });
            });

            // Handle display of the Reject Request popup
            $(document).onjs('click', jsSelectors.rejectLink, function () {
                requestKeyHiddenField.val($(this).data("route-requestkey"));
                requestorNameHiddenField.val($(this).data("route-name"));

                var requestorName = $(this).data("route-name");
                var requestorEmail = $(this).data("route-email");

                modalRequestedBy.html(`${requestorName} (${requestorEmail})`);

                modalRejectReasonTextArea.val("");

                modalPopup.modal('show');

                return false;
            })
    
            // Handle the modal 'Close' button event.
            modalPopupCancelButton.click(function () {
                modalPopup.modal('hide');
                return false;
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);